import { Text, Image } from '@ui/atoms';
import texts from '@components/Products/FixedDeposits/en.json';
import { replaceKeysWithValues } from '@helpers/miscelleanous';
import Button from '@ui/atoms/design-system/Button';

const HeroSection = ({ fdInterestRate, handleOnClick }) => {
    return (
        <div className="relative px-4 xl:px-10 pb-10 xl:bg-gradient-to-b from-bgColor-50 to-bgColor-100 page-wrapper z-10">
            <div className="relative flex flex-col items-center z-50">
                <Text
                    content={texts.heroSection.title}
                    className="h3-semibold md:h2-semibold xl:h1-semibold text-center text-primary-500"
                    htmlTag="h1"
                    isInnerHtml
                />
                <Text
                    content={replaceKeysWithValues(
                        texts.heroSection.description,
                        {
                            '{interest}': fdInterestRate,
                        }
                    )}
                    className="p4-regular xl:p2-regular text-center text-basicBlack mt-4"
                    isInnerHtml
                />
                <div className="flex gap-4 mt-6">
                    {texts.heroSection.fdBenefits.map((benefit, index) => (
                        <div
                            key={index}
                            className="text-center max-w-[200px] flex flex-col gap-1 items-center"
                        >
                            <div className="w-7 h-7 mt-1">
                                <Image src={benefit.icon} alt={benefit.title} />
                            </div>
                            <Text
                                content={benefit.title}
                                className="p4-semibold text-primary-500"
                            />
                            <Text
                                content={benefit.description}
                                className="p4-regular text-basicBlack"
                            />
                        </div>
                    ))}
                </div>
                <div className="mt-8">
                    <Button
                        onClick={handleOnClick}
                        id="bookFd"
                        buttonSize="large"
                        buttonText={texts?.bookFdNow}
                    />
                </div>
                <Text
                    content={texts.heroSection.tcApply}
                    className="p5-regular text-gray-500 mt-3 xl:hidden"
                />
            </div>
            <div className="absolute bottom-4 right-12">
                <Text
                    content={texts.heroSection.tcApply}
                    className="p5-regular text-gray-500 hidden xl:block"
                />
            </div>
            <Image
                src={'/images/products/sdis-bg-top.svg'}
                className="xl:max-w-fit absolute bg-transparent -top-8 lg:-top-20 -left-20 xl:left-0 xl:right-0 xl:mx-auto z-0"
            />
        </div>
    );
};

export default HeroSection;
